// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallAddSpeakerLink__link-a8fe89 {
  display: flex;
  align-items: center;
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--brand-primary-40);
  margin: 12px 24px;
  cursor: pointer;
  text-decoration: none;
  margin-inline-end: auto;
}

.CallAddSpeakerLink__icon-ea36ec {
  margin-inline-end: 24px;
  fill: currentColor;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/popups/Permissions/CallPermissionsPopup/components/CallAddSpeakerLink/CallAddSpeakerLink.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,0CAAA;EACA,8BAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,uBAAA;AACF;;AAEA;EACE,uBAAA;EACA,kBAAA;AACF","sourcesContent":[".link {\n  display: flex;\n  align-items: center;\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--brand-primary-40);\n  margin: 12px 24px;\n  cursor: pointer;\n  text-decoration: none;\n  margin-inline-end: auto;\n}\n\n.icon {\n  margin-inline-end: 24px;\n  fill: currentColor;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `CallAddSpeakerLink__link-a8fe89`,
	"icon": `CallAddSpeakerLink__icon-ea36ec`
};
module.exports = ___CSS_LOADER_EXPORT___;
